import * as React from "react";
import { Redirect } from "react-router-dom";
import { FormBar, FormBarSize } from "@vwpfs/mary-air-lib/components/air/07-organisms/FormBar";
import { UserRoles } from "../../../../../../store/AppTypes";
import { ThemeShadowSizes, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { Props as PremiumProps } from "../Tabs/Premium";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Icon, IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { FieldSet } from "@vwpfs/mary-air-lib/components/air/06-molecules/FieldSet";
import { Form } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

interface OwnProps {
    asAudit?: boolean;
    sidebarCollapsed: boolean
}

type Props = OwnProps & PremiumProps;
/**
 *
 * @param props
 */
export const PremiumView: React.FC<Props> = (props: Props) => {
    const premium = props.formData &&
            props.formData.content &&
            props.formData.content.policyPremium ?
        props.formData.content.policyPremium : undefined;
    return (
        <React.Fragment>
            <Div theme={{ shadow: ThemeShadowSizes.TINY }}>
                <Container
                    theme={{
                        palette: ThemePalette.CONTRAST_PRIMARY,
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    {props.resultsSuccess && (
                        <Redirect to={`/policies/${props.policyId ?? ""}`} />
                    )}
                    <Form>
                        <FieldSet
                            title={`Max. ${premium?.maxKW ?? ""} kW`}
                            key={`tariff-${premium?.id ?? ""}`}
                        >
                            <Div className="scl-b-row">
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Premium"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.premium}
                                        asSummary
                                    />
                                </Grid>
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Tax"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.tax}
                                        asSummary
                                    />
                                </Grid>
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Net Premium"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.netPremium}
                                        asSummary
                                    />
                                </Grid>
                            </Div>
                            <Div className="scl-b-row">
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Cost"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.cost}
                                        asSummary
                                    />
                                </Grid>
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Net Premium Excluding Cost"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.netPremiumExCost}
                                        asSummary
                                    />
                                </Grid>
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Commission VWPFS"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.commissionVWPFS}
                                        asSummary
                                    />
                                </Grid>
                            </Div>
                            <Div className="scl-b-row">
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Net mij"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.netMij}
                                        asSummary
                                    />
                                </Grid>
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Frontier"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.frontier}
                                        asSummary
                                    />
                                </Grid>
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Insurer"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.insurer}
                                        asSummary
                                    />
                                </Grid>
                            </Div>
                            <Div className="scl-b-row">
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Sign Committee Damage"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.signCommitteeDamage}
                                        asSummary
                                    />
                                </Grid>
                                <Grid
                                    size={{ xs: 12, md: 4 }}
                                >
                                    <FormField
                                        label="Incasso Provision"
                                        type={FieldTypes.CurrencyDisplay}
                                        value={premium?.incassoProvision}
                                        asSummary
                                    />
                                </Grid>
                            </Div>
                        </FieldSet>
                    </Form>
                    {props.user?.userRole !== UserRoles.EW_ADMIN_READONLY && props.asAudit !== true ?
                        <FormBar
                            title="Manage premium"
                            size={props.sidebarCollapsed ? FormBarSize.WITH_COLLAPSED_SIDEBAR : undefined}
                            onClick={() => props.openPremiumRequest?.(props.policyId ?? "")}
                            showButton
                            buttonLabel={<>
                                Update premium
                                &nbsp;
                                &nbsp;
                                <Icon name={IconNames.ARROW_RIGHT} />
                            </>}
                        /> : <></>}
                </Container>
            </Div>
        </React.Fragment>
    );
};
